import { TiTick } from "react-icons/ti";
import bannerImg from "@assets/images/Magnifying-glass-banner-image.avif";
import RippleButton from "@components/RippleAnimation";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";
import { AnimatedBox } from "../AnimatedBox";
import CustomBanner from "@components/CustomBanner";
import GetAQuoteButton from "@components/GetAQuoteButton";
import FrostedContainer from "../../../../components/FrostedContainer";
export const Banner = () => {
  return (
    <> 
      <Head>
        <title>The Best SEO Service Company for Great Falls, VA</title>
        <meta
          name="description"
          content="Boost your visibility with expert SEO services from Great Falls, VA based agency. We help businesses across DC, Maryland, and Northern Virginia grow online."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/search-engine-optimization"
        />
      </Head>
      <CustomBanner
        bgImg={bannerImg}
                    customHeight={true}
        BannerImageAlt="A low-fidelity UI/UX design showing the skeleton, important components and work-flow of a website."
      > 
        <div className="flex justify-start flex-start ">
                     <FrostedContainer>            
                     
        
            {/* <div className="frosted-card"> */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <h1 className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px]  leading-[1.1] font-bold    md:pr-0 heading-1 text-white">
                Best SEO Company for Business in{" "}
                <span className="whitespace-nowrap"> Great Falls, </span> VA and
                Beyond{" "}
              </h1>
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="block text-[20px] md:text-[26px] lg:text-[37px] xl:text-[32px] 2xl:text-[35px] leading-[1] font-semibold heading-2 text-white"
            >
              {" "}
              We are a results-driven SEO service company, helping businesses
              grow their fundamentals.
            </motion.h2>
            <p className="text-base leading-[1.625rem] font-semibold text-white paragraph ">
              Whether you are a small business looking for affordable SEO
              services or an enterprise needing a complex technical strategy,
              our proactive approach delivers the best SEO for long-term,
              sustainable growth. We’ve moved beyond just simple keyword
              rankings to focus on true brand growth and recognition. We’re
              staying one step ahead in the constantly shifting SEO landscape.
            </p>

            <div className="">
              <GetAQuoteButton title='Get Started' text="Get Started" />
            </div>
                       </FrostedContainer>

        </div>
      </CustomBanner>
    </>
  );
};
